// apps/client/src/net/clock.ts — offset from the min-RTT ping sample (§4.7, contract change 14)
import { tuning } from '@whiskerton/content';

export class ClockSync {
  offsetMs = 0;
  private best: number | null = null;
  private readonly send: (c: number) => boolean;
  private readonly perf: () => number;
  private readonly origin: number;
  constructor(send: (c: number) => boolean, perf: () => number = () => performance.now(), origin: number = performance.timeOrigin) {
    this.send = send; this.perf = perf; this.origin = origin;
  }
  /** The synced town clock, epoch ms. Device clocks are never trusted: only the server's samples set the offset. */
  now(): number { return this.origin + this.perf() + this.offsetMs; }
  /** A snapshot's serverNow sets the clock until the first pong lands. */
  seed(serverNow: number): void { if (this.best === null) this.offsetMs = serverNow - (this.origin + this.perf()); }
  /** offset = s + rtt/2 − (timeOrigin + receivedAt), kept only from the lowest round trip seen (contract change 14). */
  onPong(c: number, s: number): void {
    const recv = this.perf(), rtt = recv - c;
    if (rtt < 0 || (this.best !== null && rtt >= this.best)) return;
    this.best = rtt;
    this.offsetMs = s + rtt / 2 - (this.origin + recv);
  }
  /** Sends `clockPings` pings `clockPingGapMs` apart; the pongs refine the offset as they arrive. */
  async sync(): Promise<void> {
    this.best = null;
    for (let i = 0; i < tuning.net.clockPings; i++) {
      if (!this.send(this.perf())) return;
      await new Promise((r) => setTimeout(r, tuning.net.clockPingGapMs));
    }
  }
}
